// card.ts — CARD_CSS: die token-basierte Card-Hülle als Klasse (PFS-682/683).
//
// Für Composites, die ihre Card in EIGENER Shadow rendern (login-form, mfa-*)
// und bisher `.card` lokal nachkochten. Spiegelt die Optik-Werte des
// <pfs-card>-Elements (layout/pfs-card.ts) IDENTISCH — Abstimmpunkt (a):
// Inset via --pfs-space-inset (nicht die Foundation-card-x/y-Tokens).
//
// Bewusstes, sanktioniertes Duplikat zum <pfs-card>-Element
// ([[feedback_duplicate_must_be_identical]]): das Element stylt :host, diese
// Konstante die Klasse `.card` — dieselben Werte über die :host/Klassen-Grenze.
// Ändert sich pfs-card, hier nachziehen (und umgekehrt). KEIN flex/gap hier —
// das ist Section-Rhythmik (pfs-card- bzw. Consumer-Sache), nicht die Hülle.
export const CARD_CSS = `
.card {
  background: var(--pfs-color-surface);
  border: 1px solid var(--pfs-color-outline);
  border-radius: var(--pfs-radius-md, 0.5rem);
  box-shadow: var(--pfs-shadow-card, 0 1px 2px rgba(16, 33, 43, 0.06));
  padding: var(--pfs-space-inset, 1rem);
  width: 100%;
  box-sizing: border-box;
}
`;
